
    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/agent00/work/567a73f84321482c/communities/communities-blog-ooi/src/components/PostList/Widget/index.tsx';
    import createController from '/home/builduser/agent00/work/567a73f84321482c/communities/communities-blog-ooi/src/components/PostList/controller.ts';

    
var createHttpClient = null;

    
var initI18n = null;

    

    var createExperiments = null;
    var createWidgetExperiments = null;
    

    

    var createErrorMonitor = null;
    

    
var I18nextProvider = React.Fragment;


    var PureExperimentsProvider = React.Fragment;
    var ExperimentsProvider = React.Fragment;
    

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

var HttpProvider = React.Fragment;

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  HttpProvider,
}

    import * as fedopsLogger from '@wix/fe-essentials/fedops';

    
  import * as viewerApp from '/home/builduser/agent00/work/567a73f84321482c/communities/communities-blog-ooi/src/viewer.app.ts';
    var importedApp = viewerApp;

    var componentName = 'PostList';
    var projectName = 'communities-blog-ooi';
    var sentryConfig = {
      DSN: 'https://2062d0a4929b45348643784b5cb39c36@sentry.wixpress.com/1643',
      id: '2062d0a4929b45348643784b5cb39c36',
      projectName: 'communities-blog-ooi',
      teamName: 'blogas',
      
    };
    var stylesParams = null;
    var experimentsConfig = null;
    var translationsConfig = {"enabled":false,"icuEnabled":false};
    var defaultTranslations = null;
    var biConfig = null;
    var appDefinitionId = "14bcded7-0066-7c35-14d7-466cb3f09103";
    var componentId = "813eb645-c6bd-4870-906d-694f30869fd9";
    var localeDistPath = 'assets/locales';
    var shouldUseEssentials = false;
    var shouldSkipMultipleRendersAfterViewModeChange = true;
    var withErrorBoundary = true;

    import { createVisitorBILogger as biLogger } from '/home/builduser/agent00/work/567a73f84321482c/communities/communities-blog-ooi/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      experimentsConfig: experimentsConfig,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
